import React from "react"
import Img from "gatsby-image"

const MiniGallery = ({ data }) => {
  return (
    <React.Fragment>
      <div className="container">
        <div className="gallery">
          {data.map(image => {
            return (
              <figure
                key={image.node.id}
                className={`galleryItem galleryItem-${image.node.name}`}
              >
                <Img
                  className="galleryImg"
                  fluid={image.node.childImageSharp.fluid}
                />
              </figure>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

export default MiniGallery
